// extracted by mini-css-extract-plugin
module.exports = {"colorSwatch":"ColorSwatch_colorSwatch__2gYiK","box":"ColorSwatch_box__cm3CQ","title":"ColorSwatch_title__gRjIL","color":"ColorSwatch_color__yBbU9"};